import { Component, Input, OnInit } from '@angular/core';
import { WCPageDetailsResponseJSON } from "./../common/JSON/wcPage/WC-Page-Details-Response-JSON";


@Component({
  selector: 'altSurvey-container',
  templateUrl: './Container.component.html'
})
export class ContainerComponent implements OnInit {

  // @Input() wCPageDetailsResponseJSON: WCPageDetailsResponseJSON;

  constructor() {

  }

  ngOnInit() {
  }

}
